import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { verifyEmail } from "../utils/fetchFunctions";
import FormContainer from "../components/FormContainer";
import Button from "../components/Button";
import "./auth.css";
import "./emailverification.css";

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying, success, already_verified, error
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get("token");
    const email = searchParams.get("email");

    if (!token || !email) {
      setStatus("error");
      setMessage(
        "Invalid verification link. Please check the link from your email."
      );
      setLoading(false);
      return;
    }

    const handleVerification = async () => {
      try {
        const data = await verifyEmail(token, email);
        // Check if already verified (200 status with specific message)
        if (data.message && data.message.includes("bereits verifiziert")) {
          setStatus("already_verified");
          setMessage("Your email address has already been verified.");
        } else {
          setStatus("success");
          setMessage(
            "Your email address has been successfully verified. You can now log in."
          );
        }
      } catch (err) {
        setStatus("error");
        setMessage(
          err.message ||
            "Email verification failed. The link may have expired."
        );
      } finally {
        setLoading(false);
      }
    };

    handleVerification();
  }, [searchParams]);

  const getStatusIcon = () => {
    switch (status) {
      case "success":
      case "already_verified":
        return "✓";
      case "error":
        return "✗";
      default:
        return "";
    }
  };

  const getStatusIconClass = () => {
    return `verification-icon verification-icon--${status}`;
  };

  const getMessageClass = () => {
    return `verification-message verification-message--${status}`;
  };

  return (
    <main className="auth-page">
      <FormContainer>
        <header>
          <h1 className="auth-title">Email Verification</h1>
        </header>

        <div className="verification-container">
          {loading ? (
            <>
              <div className="verification-loading-icon">⏳</div>
              <p className="auth-subtitle">Verifying email...</p>
            </>
          ) : (
            <>
              <div className={getStatusIconClass()}>{getStatusIcon()}</div>
              <p className={getMessageClass()}>{message}</p>
              {status === "success" || status === "already_verified" ? (
                <Button
                  className="auth-button"
                  onClick={() => navigate("/login")}
                >
                  To Login
                </Button>
              ) : (
                <Button
                  className="auth-button"
                  onClick={() => navigate("/register")}
                >
                  To Registration
                </Button>
              )}
            </>
          )}
        </div>

        <footer className="auth-footer">
          <Link to="/login">Back to Login</Link>
        </footer>
      </FormContainer>
    </main>
  );
};

export default EmailVerification;
